import {css} from "lit";

export const heroTeaserOnDarkStyles = css`

    --_hero-teaser__color: var(--sbkHeroTeaserColorFgColorOnDarkDefault);
    --_hero-teaser__bg-color: var(--sbkHeroTeaserColorFgColorOnDarkefault);

`;
